/**
 * JSON-LD structured data helpers
 */

// Numery rejestrowe Fundacji „Znajdki" jako schema.org PropertyValue.
// Współdzielone przez wszystkie schematy opisujące organizację.
export const registrationIdentifiers = [
  { '@type': 'PropertyValue', 'propertyID': 'KRS', 'value': '0000437387' },
  { '@type': 'PropertyValue', 'propertyID': 'NIP', 'value': '1132860384' },
  { '@type': 'PropertyValue', 'propertyID': 'REGON', 'value': '146390781' }
];

export const getOrganizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  'name': 'Fundacja Znajdki',
  'url': 'https://znajdki.pl',
  'logo': 'https://znajdki.pl/photos/logo/logo.png',
  'description': 'Fundacja Znajdki pomaga bezdomnym zwierzętom znaleźć nowy dom. Adoptuj, wspieraj, zostań wolontariuszem.',
  'foundingDate': '2012',
  'legalName': 'Fundacja „Znajdki"',
  'taxID': '1132860384',
  'vatID': 'PL1132860384',
  'identifier': registrationIdentifiers,
  'numberOfEmployees': {
    '@type': 'QuantitativeValue',
    'value': '20+'
  },
  'address': {
    '@type': 'PostalAddress',
    'streetAddress': 'ul. Leona Berensona 90',
    'addressLocality': 'Warszawa',
    'addressRegion': 'Mazowieckie',
    'postalCode': '03-287',
    'addressCountry': 'PL'
  },
  'contactPoint': {
    '@type': 'ContactPoint',
    'telephone': '+48-664-821-160',
    'email': 'znajdki2012@gmail.com',
    'contactType': 'customer service'
  },
  'sameAs': [
    'https://www.facebook.com/znajdki/',
    'https://www.instagram.com/fundacja_znajdki/'
  ]
});

export const getWebsiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  'name': 'Fundacja Znajdki',
  'url': 'https://znajdki.pl',
  'description': 'Fundacja Znajdki pomaga bezdomnym zwierzętom znaleźć nowy dom. Adoptuj, wspieraj, zostań wolontariuszem.',
  'publisher': {
    '@type': 'Organization',
    'name': 'Fundacja Znajdki'
  }
});

export const getBreadcrumbSchema = (items: Array<{ name: string; url: string }>) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  'itemListElement': items.map((item, index) => ({
    '@type': 'ListItem',
    'position': index + 1,
    'name': item.name,
    'item': item.url
  }))
});

export const getPetSchema = (pet: any) => {
  const imageUrl = pet.image?.asset?._ref 
    ? `https://cdn.sanity.io/images/tcqsp9oq/production/${pet.image.asset._ref.replace('image-', '').replace(/\-[a-z]+$/i, '.jpg')}`
    : `https://znajdki.pl/images/animals/fundacja-znajdki-zwierzeta-001.webp`;
  
  return {
    '@context': 'https://schema.org',
    '@type': 'AnimalShelter',
    'name': 'Fundacja Znajdki',
    'animal': {
      '@type': pet.mainCategory === 'dog' ? 'Dog' : 'Cat',
      'name': pet.name,
      'description': pet.description,
      'image': imageUrl,
      'url': `https://znajdki.pl/zwierze/${pet.slug?.current || ''}`,
      'birthDate': pet.birthDate,
      'sex': pet.gender === 'male' ? 'Male' : 'Female'
    }
  };
};

export const getArticleSchema = (post: any) => {
  const imageUrl = post.mainImage?.asset?._ref
    ? `https://cdn.sanity.io/images/tcqsp9oq/production/${post.mainImage.asset._ref.replace('image-', '').replace(/\-[a-z]+$/i, '.jpg')}`
    : `https://znajdki.pl/images/animals/fundacja-znajdki-zwierzeta-001.webp`;
  
  const authorName = post.author?.name || 'Fundacja Znajdki';
  const authorImage = post.author?.image?.asset?._ref
    ? `https://cdn.sanity.io/images/tcqsp9oq/production/${post.author.image.asset._ref.replace('image-', '').replace(/\-[a-z]+$/i, '.jpg')}`
    : 'https://znajdki.pl/photos/logo/logo.png';
  
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    'headline': post.title,
    'description': post.excerpt || post.title,
    'image': imageUrl,
    'datePublished': post.publishedAt,
    'dateModified': post._updatedAt || post.publishedAt,
    'url': `https://znajdki.pl/aktualnosci/${post.slug?.current || ''}`,
    'author': {
      '@type': 'Person',
      'name': authorName,
      'image': authorImage
    },
    'publisher': {
      '@type': 'Organization',
      'name': 'Fundacja Znajdki',
      'logo': {
        '@type': 'ImageObject',
        'url': 'https://znajdki.pl/photos/logo/logo.png'
      }
    }
  };
};

export const getDonationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'NGO',
  'name': 'Fundacja Znajdki',
  'legalName': 'Fundacja „Znajdki"',
  'description': 'Organizacja pożytku publicznego działająca na rzecz bezdomnych zwierząt',
  'taxID': '1132860384',
  'vatID': 'PL1132860384',
  'identifier': registrationIdentifiers,
  'address': {
    '@type': 'PostalAddress',
    'streetAddress': 'ul. Leona Berensona 90',
    'addressLocality': 'Warszawa',
    'postalCode': '03-287',
    'addressCountry': 'PL'
  }
});

